define('collections/country_distributors',['require','collections/base','models/country_distributor'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/country_distributor");

    return BaseCollection.extend({
        model: Model,
        url: 'country-distributors.json'
    });
});

